"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckGroup = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var CheckGroup = function (_a) {
    var options = _a.options, onChange = _a.onChange, value = _a.value, colProps = _a.colProps, _b = _a.rowProps, rowProps = _b === void 0 ? {} : _b, _c = _a.renderItem, renderItem = _c === void 0 ? function (_a) {
        var node = _a.node;
        return node;
    } : _c, _d = _a.activeColor, activeColor = _d === void 0 ? "#1890FF" : _d;
    return (react_1.default.createElement(antd_1.Row, __assign({}, rowProps), options.map(function (rest) {
        var val = rest.value, title = rest.title;
        var isChecked = !!(value === null || value === void 0 ? void 0 : value.includes(val));
        return (react_1.default.createElement(antd_1.Col, __assign({}, colProps, { onClick: function () {
                if (value === null || value === void 0 ? void 0 : value.includes(val)) {
                    // remove it from value
                    onChange === null || onChange === void 0 ? void 0 : onChange(value.filter(function (v) { return v !== val; }));
                }
                else {
                    // add it to value
                    onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], (value || [])), [val]));
                }
            } }), renderItem({
            isChecked: isChecked,
            node: !isChecked ? (react_1.default.createElement(antd_1.Typography, null, title)) : (react_1.default.createElement(antd_1.Space, null,
                react_1.default.createElement(icons_1.CheckOutlined, { style: { color: activeColor } }),
                react_1.default.createElement(antd_1.Typography, { style: { color: activeColor } }, title))),
            activeColor: activeColor,
            rest: rest,
        })));
    })));
};
exports.CheckGroup = CheckGroup;
